
import ProductsList from '../components/stripe/ProductsList.vue'

const axios = require('axios')

export default {
  layout: 'server-render',
  components: {
    ProductsList
  },
  data() {
    return {
      step: 1,
      isLoading: false,
      foundThroughArr: ['Facebook', 'Referral', 'Instagram', 'Google', 'Other'],
      subscriptionTypes: [
        'In Person',
        'Virtual Training',
        'Online Training',
        '4 Week Shred Program'
      ],
      foundThrough: '',
      registration: {
        fullname: '',
        email: '',
        phone: '',
        subscriptionType: '',
        occupation: '',
        achievement: [],
        fitnessLevel: '',
        healthyFood: '',
        reason: [],
        foundThrough: '',
        message: null
      },
      validated: true
    }
  },
  methods: {
    selectedSubscription(data) {
      this.registration.subscriptionType = data.product.name
    },
    sendForm() {
      window.scrollTo({
        top: 0,
        left: 0
      })
      if (this.foundThrough.length) {
        this.registration.foundThrough = this.foundThrough
      }
      if (this.registration.reason.length) {
        this.isLoading = true
        axios.post(`${process.env.API_URL}/sendMail`, this.registration).then(() => {
          this.isLoading = false
          this.$router.push('/')
          this.$snotify.success('Your message has been sent, Michelle will be with you shortly.')
          this.formReset()
        })
      } else {
        this.notifyError()
      }
    },
    formReset() {
      this.registration = {
        fullname: '',
        email: '',
        phone: '',
        subscriptionType: '',
        occupation: '',
        achievement: [],
        fitnessLevel: '',
        healthyFood: '',
        reason: [],
        foundThrough: '',
        message: null
      }
      this.step = 1
    },
    notifyError() {
      this.$snotify.error('Please chose one of the answers to continue.')
    },
    prev() {
      if (this.step >= 2) {
        this.step -= 1
        window.scrollTo({
          top: 0,
          left: 0
        })
      }
    },
    next() {
      const user = this.registration
      const emailVal = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.registration.email)

      if (user.fullname.length > 1 && emailVal && user.subscriptionType) {
        if (this.step < 2) {
          this.step += 1
          window.scrollTo({
            top: 0,
            left: 0
          })
        } else if (this.registration.achievement.length) {
          if (this.step === 2) {
            this.step += 1
            window.scrollTo({
              top: 0,
              left: 0
            })
          } else if (this.registration.fitnessLevel) {
            if (this.step === 3) {
              this.step += 1
              window.scrollTo({
                top: 0,
                left: 0
              })
            } else if (this.registration.healthyFood) {
              if (this.step === 4) {
                this.step += 1
                window.scrollTo({
                  top: 0,
                  left: 0
                })
              }
            } else {
              this.notifyError()
            }
          } else {
            this.notifyError()
          }
        } else {
          this.$snotify.error('Please chose at least 1 answer to continue.')
        }
      } else {
        this.validated = false
        setTimeout(() => {
          this.validated = true
        }, 6000)
        this.$snotify.error('Please fill all required fields')
      }
    }
  }
}
